<div class="content-section" [ngClass]="{ 'expand' : layoutService.expandedMenu }">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-div">
      <div class="col p-0 d-flex justify-content-between align-items-center">
        <div class="col-11 p-0">
          <h2 class="background_title">{{ 'CHECK.HYGIENE_CHECK_OVERVIEW' | translate }}</h2>
        </div>
      </div>
    </div>
    <div class="container-fluid">
            <nav class="nav nav-pills nav-title">
                <a *ngIf="appConfig.userData.roleName.roleId > 3" class="nav-link" routerLinkActive="active" routerLink="/hygiene-check-menu/new-hygiene-check" routerLinkActive='active'>{{ 'CHECK.MENU_NEW_CHECK' | translate }}</a>
                <a *ngIf="appConfig.userData.roleName.roleId > 3" class="nav-link" routerLinkActive="active" routerLink="/hygiene-check-menu/hygiene-check" routerLinkActive='active'>{{ 'CHECK.OVERVIEW' | translate }}</a>
                <a *ngIf="appConfig.userData.roleName.roleId < 5" class="nav-link" routerLinkActive="active" routerLink="/hygiene-check-menu/hygiene-check-editor" routerLinkActive='active'>{{ 'CHECK.EDITOR_TITLE' | translate }}</a>
            </nav>
            <hr class="nav-separator">

            <div class="page-content-2">
                <router-outlet></router-outlet>
            </div>
    </div>
</div>
